import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { constant } from "common/constant";
import { postApi } from "common/services/api";
import { getApi } from "common/services/api";
import { API_PATHS } from "common/services/apiPaths";
import { toast } from "react-toastify";


const initialState = {
    applications: [],
    loading: false,
    error: null,
    addLoading: false,
    sendingRejectionEmail: false,
    sendingInviteEmail: false,
};


const applicationSlice = createSlice({
    name: "applications",
    initialState,
    reducers: {
        fetchApplicationsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchApplicationsSuccess: (state, action) => {
            state.loading = false;
            state.applications = action.payload;
        },
        fetchApplicationsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        setSendingRejectionEmail: (state, action) => {
            state.sendingRejectionEmail = action.payload;
        },
        setSendingInviteEmail: (state, action) => {
            state.sendingInviteEmail = action.payload;
        },
        extraReducers: (builder) => {
            builder
                .addCase(addApplication.pending, (state) => {
                    state.addLoading = true;
                    state.error = null;
                })
                .addCase(addApplication.fulfilled, (state) => {
                    state.addLoading = false;
                })
                .addCase(addApplication.rejected, (state, action) => {
                    state.addLoading = false;
                    state.error = action.payload;
                });
        },
    },
});


export const {
    fetchApplicationsStart,
    fetchApplicationsSuccess,
    fetchApplicationsFailure,
    setSendingRejectionEmail,
    setSendingInviteEmail,
} = applicationSlice.actions;


export default applicationSlice.reducer;


export const getApplications = () => async (dispatch) => {
    try {
        dispatch(fetchApplicationsStart());
        const response = await getApi(API_PATHS.RECRUITMENT_APPLICATION);
        dispatch(fetchApplicationsSuccess(response?.data?.data));
    } catch (error) {
        dispatch(fetchApplicationsFailure(error.message || constant.failedToLoadApplications));
    }
};

export const addApplication = createAsyncThunk(
    "applications/addApplication",
    async ({ values, formik, navigate }, { rejectWithValue }) => {
        console.log({ values });
        try {
            const response = await postApi(API_PATHS.RECRUITMENT_APPLICATION, values);
            if (response.status === 201) {
                formik.resetForm();
                navigate("/recruitment/applications");
            }
            return response.data;
        } catch (error) {
            return rejectWithValue("Something went wrong");
        }
    }
);

export const sendRejectionEmail = (applicationId, templateId, candidateName, jobTitle) => async (dispatch) => {
    try {
        dispatch(setSendingRejectionEmail(true));
        const response = await postApi(
            `api/recruitment/application/${applicationId}/send-rejection-email`,
            { templateId, candidateName, jobTitle }
        );
        if (response.status === 200) {
            toast.success("Rejection email sent successfully");
            return { type: 'applications/sendRejectionEmail/fulfilled' };
        }
    } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to send rejection email");
        throw error;
    } finally {
        dispatch(setSendingRejectionEmail(false));
    }
};

export const sendInviteEmail = (applicationId, payload) => async (dispatch) => {
    try {
        dispatch(setSendingInviteEmail(true));
        const response = await postApi(
            `api/recruitment/application/${applicationId}/send-invite-email`,
            payload
        );
        if (response.status === 200) {
            toast.success("Invite email sent successfully");
            return { type: 'applications/sendInviteEmail/fulfilled' };
        }
    } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to send invite email");
        throw error;
    } finally {
        dispatch(setSendingInviteEmail(false));
    }
};
